import { FaCircleCheck } from "react-icons/fa6"
import { useNavigate } from "react-router-dom";
import {
  Box,
  Center,
  VStack,
} from "@chakra-ui/react"
import { Button, Text } from "@/components"
import { ComplianceType } from "@/types"

interface Props {
  complianceType: ComplianceType
}

export const CompletedTaskComponent = ({ complianceType }: Props) => {
  const navigate = useNavigate()
  return (
    <Center w="100%" h="100%">
      <VStack
        position="relative"
        zIndex={1}
        w="40%"
        p={5}
        borderRadius={10}
        bg="card.bg"
        boxShadow="md"
        mt={20}
      >
        <Box borderRadius={5} bg="green.300" p={3}>
          <FaCircleCheck size={30} color="white" />
        </Box>
        <Text fontSize="lg" fontWeight="bold" textAlign="center" mt={2} mb={2}>
          {`${complianceType} completed!`}
        </Text>
        <Text fontSize="sm" textAlign="center" mb={5}>
          {`Thank you for signing our ${complianceType}. If you would like to download the signed copy please go to the Documents Page.`}
        </Text>
        <Button variant="solid" onClick={() => navigate("/client/documents")}>Go To Documents</Button>
      </VStack>
    </Center>
  )
}